import { SafeLocalStorage } from '#pplx/frontend/browser-storage/localStorage.js';
const PPLX_GPC_OPTOUT_KEY = 'pplx_gpc_optout';
export function isGpcActive() {
    if (typeof navigator !== 'undefined' && 'globalPrivacyControl' in navigator) {
        const active = navigator.globalPrivacyControl === true;
        if (active) {
            SafeLocalStorage.setItem(PPLX_GPC_OPTOUT_KEY, 'true');
        }
        else {
            SafeLocalStorage.removeItem(PPLX_GPC_OPTOUT_KEY);
        }
        return active;
    }
    return SafeLocalStorage.getItem(PPLX_GPC_OPTOUT_KEY) === 'true';
}
//# sourceMappingURL=gpc.js.map